import { CashFundPreferences } from 'src/types/registry'

export const noPaymentPreferencesSelected = (
  cashFundPreferences?: CashFundPreferences
): boolean =>
  !!cashFundPreferences?.paymentPreferences?.every((pref) => !pref.selected)
